import * as S from './style';

const SocietyGuide = () => (
	// const navigate = useNavigate();
	// const isMobile = useIsMobile(900);
	// const [page, setPage] = useState(1);
	// const [isOpenShare, setIsOpenShare] = useState(false);
	// const [conferencePk, setConferencePk] = useState('');

	// const { data: pastConferencesData, refetch: refetchGetPastConferences } = useGetPastConferencesApi({
	// 	page: page,
	// 	row: 10,
	// });

	// const handleOpenModalShare = (bool: boolean) => {
	// 	setIsOpenShare(bool);
	// };

	// const handleOpenDetail = (pdfUrl: string | null, pk: string) => {
	// 	setConferencePk(pk);
	// 	navigate(`/society/guide/${pk}`);
	// };

	// const handleMobileItemClick = (pk: string) => {
	// 	setConferencePk(pk);
	// 	navigate(`/society/guide/${pk}`);
	// };

	// useEffect(() => {
	// 	const fetchData = async () => {
	// 		try {
	// 			await refetchGetPastConferences();
	// 		} catch (error) {
	// 			console.error('데이터 로딩 중 오류 발생:', error);
	// 			// 필요하다면 에러 처리 로직 추가
	// 		}
	// 	};

	// 	fetchData(); // 정의된 async 함수를 즉시 호출
	// }, [conferencePk]);

	<S.Container>
		<S.SocietyListContainer>
			<S.SocietyListTitle>학술행사 안내</S.SocietyListTitle>
			<S.Table>
				<S.TableHeadCell className="center">학술대회명</S.TableHeadCell>
				<S.TableHeadCell className="center">일시</S.TableHeadCell>
				<S.TableHeadCell className="center">장소</S.TableHeadCell>

				<S.TableCell className="point min-height center">2026년 (사)대한화장품학회 춘계학술대회</S.TableCell>
				<S.TableCell className="center">2026.05.15(금)</S.TableCell>
				<S.TableCell className="center">서울드래곤시티 한라홀</S.TableCell>

				<S.TableCell className="point min-height center">2026년 화장품의 날 학회 세미나</S.TableCell>
				<S.TableCell className="center">2026.09.08(화)</S.TableCell>
				<S.TableCell className="center">더 프라자 호텔 다이아몬드홀</S.TableCell>

				<S.TableCell className="point min-height center">2026년 (사)대한화장품학회 제 6차 정기총회 및 추계학술대회</S.TableCell>
				<S.TableCell className="center">2026.11.27(금)</S.TableCell>
				<S.TableCell className="center">서울드래곤시티 한라홀</S.TableCell>
			</S.Table>
		</S.SocietyListContainer>
		{/* <S.SocietyListContainer>
				{pastConferencesData?.total_count !== 0 ? (
					<S.SocietyBoardBox>
						{!isMobile ? (
							<TablePagination activePage={page} totalItems={pastConferencesData?.total_count ?? 0} onChange={(page) => setPage(page)}>
								<BoardTable
									columns={generateColumns(pastConferencesData?.conferences ?? [])}
									page={page}
									data={pastConferencesData?.conferences ?? []}
									totalItems={pastConferencesData?.total_count ?? 0}
									onRowClick={handleOpenDetail}
								/>
							</TablePagination>
						) : (
							<TablePagination activePage={page} totalItems={pastConferencesData?.total_count ?? 0} onChange={(page) => setPage(page)}>
								<SocietyList data={pastConferencesData?.conferences ?? []} onItemClick={handleMobileItemClick} />
							</TablePagination>
						)}
					</S.SocietyBoardBox>
				) : (
					<S.SocietyBoardBox>
						<S.NoData>등록 내역이 없습니다.</S.NoData>
					</S.SocietyBoardBox>
				)}

				<S.Table>
					<S.TableHeadCell className="center">직책</S.TableHeadCell>
					<S.TableHeadCell className="center">성명</S.TableHeadCell>
					<S.TableHeadCell className="center">소속</S.TableHeadCell>

					<S.TableCell className="point min-height center">회장</S.TableCell>
					<S.TableCell className="center">황재성</S.TableCell>
					<S.TableCell className="center">경희대학교</S.TableCell>

					<S.TableCell className="point min-height item2_1 center">부회장</S.TableCell>
					<S.TableCell className="center">강승현</S.TableCell>
					<S.TableCell className="center">코스맥스</S.TableCell>
					<S.TableCell className="center">서병휘</S.TableCell>
					<S.TableCell className="center">아모레퍼시픽</S.TableCell>
					<S.TableCell className="center">한상근</S.TableCell>
					<S.TableCell className="center">한국콜마㈜</S.TableCell>
				</S.Table>
			</S.SocietyListContainer>
			{isOpenShare && (
				<ModalPortal>
					<ModalShare onClick={handleOpenModalShare} />
				</ModalPortal>
			)} */}
	</S.Container>
);
export default SocietyGuide;
